import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = null;

const signinDataSlice = createSlice({
  name: "signinData",
  initialState,
  reducers: {
    setSigninData: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setSigninData } = signinDataSlice.actions;
export default signinDataSlice.reducer;
